import { CircularProgress, Stack } from '@mui/material';
import { Typography } from '../../primitives/typography/typography';
import { useEffect, useState } from 'react';
import { Loading } from '../../feedback/loading-indicator/loading-indicator';

export function LoadingPage({ useSpinner }: { useSpinner?: boolean }) {
  const [warningTimeHasElapsed, setWarningTimeHasElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setWarningTimeHasElapsed(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Stack
      direction="column"
      sx={{ justifyContent: 'center', alignItems: 'center', minHeight: '110vh', gap: 5 }}
    >
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'center', gap: 5 }}>
        {useSpinner && <CircularProgress sx={{ width: '2.5rem', height: '2.5rem' }} />}
        <Loading sx={{ fontWeight: 500, fontSize: '2.5rem', color: 'primary.main' }} />
      </Stack>

      <Typography.Body
        sx={{
          fontSize: '1.2rem',
          fontWeight: 500,
          opacity: warningTimeHasElapsed ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out',
          pointerEvents: 'none',
          maxWidth: '70%',
          textAlign: 'center',
          lineHeight: 2,
          color: 'error.main',
        }}
      >
        This page is taking longer than expected to load. <br />
        Please check your internet connection.
      </Typography.Body>
    </Stack>
  );
}
